import React, { useEffect } from "react"
import { Cta } from "@components/common/cta/Cta"
import MapStyle from "./style"
import MapPin from "@assets/icons/mapPin.svg"

import * as s from "./Location.module.scss"

export const Location = ({ data }) => {
  const { title, blurb, address, directionsLink, location } = data
  const googleMapRef = React.useRef(null)

  useEffect(() => {
    const googleMapScript = document.createElement("script")
    googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCUEcsYD_vsGLAhCIZ6wyTvQTht6eR4JGY&libraries=places`
    window.document.body.appendChild(googleMapScript)

    googleMapScript.addEventListener("load", () => {
      createMap()
    })
  }, [])

  const createMap = () => {
    if (typeof window === "object") {
      if (!location.latitude || !location.longitude) return
      const map = new window.google.maps.Map(googleMapRef.current, {
        zoom: 15,
        styles: MapStyle,
        center: {
          lat: location.latitude,
          lng: location.longitude,
        },
        disableDefaultUI: true,
      })

      new window.google.maps.Marker({
        position: { lat: location.latitude, lng: location.longitude },
        icon: MapPin,
        map: map,
      })
    }
  }

  return (
    <div className={s.Location}>
      <div className={s.Inner}>
        {title && <h3 className={s.Location__title}>{title}</h3>}
        {blurb && <p className={s.Location__blurb}>{blurb}</p>}

        {address && address.length > 0 && (
          <div className={s.Location__address}>
            {address.map((address, i) => {
              return <span key={i}>{address.line}</span>
            })}
          </div>
        )}

        <Cta
          className={s.Location__cta}
          link={directionsLink.url}
          external
          title={"Get Directions"}
          target="_blank"
        />
      </div>
      <div className={s.Location__mapWrapper}>
        <div id="google-map" ref={googleMapRef} />
      </div>
    </div>
  )
}
